// FILENAME: /frontend/src/pages/SettingsPage.jsx
import React from 'react';
import Settings from '../components/Settings';
import { Box, Typography } from '@mui/material';

const SettingsPage = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>API Credentials</Typography>
      <Typography paragraph color="text.secondary">
        Enter and save your API credentials here. The Settings page shows four credential records: two for the GET enrollment‑report APIs (trade + all other programs) and two for the POST/VMT APIs (trade + all other programs). Your Client Secret will be encrypted before being saved.
      </Typography>
      <Settings />
    </Box>
  );
};

export default SettingsPage;
